import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';

export default function About() {
  return (
    <>
      <section className="w-full px-4 md:px-8 lg:px-12 pt-36 pb-10 md:pt-48 md:pb-12 bg-background-50">
        <div className="max-w-content mx-auto max-w-3xl">
          <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
            About Daniella
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl leading-[1.12] text-foreground-950">
            The Story Behind KOR&nbsp;38
          </h1>
          <p className="mt-5 font-label text-sm uppercase tracking-[0.14em] text-accent-600">
            A life of creativity, trust and connection.
          </p>
        </div>
      </section>

      {/* Row 1 — portrait LEFT, first part of the story RIGHT */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-20 bg-background-50">
        <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <div className="relative w-full aspect-[4/5] max-w-md mx-auto lg:mx-0 overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/054d0577-a2d9-4221-b3e4-558c384fd3f1_compressed_Centred-Professional-Blonde-Business-Headshot.webp"
                alt="Daniella Farrell, founder of KOR38"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal delay={120} className="space-y-5 text-base md:text-lg leading-relaxed text-foreground-700">
            <p>
              I&rsquo;m Daniella Farrell, a hairdresser, session stylist and founder of KOR38.
              Originally from Croatia, I built my career in London and found the work I love in
              hairdressing and session styling. I&rsquo;ve had opportunities to train with leading
              celebrity hairdressers and respected brands, work with VIP clients, and contribute to
              fashion shows, photo shoots and special occasions. Yet the most meaningful part has
              always been the relationships I&rsquo;ve built.
            </p>
            <p>
              A hairdresser&rsquo;s chair is a special place. Conversations unfold and trust grows.
              Over the years, clients asked me for advice and introductions far beyond hair. That
              trust grew from honesty: if I didn&rsquo;t believe a product was right for someone,
              I&rsquo;d advise against buying it, even if that meant losing a sale. Protecting the
              relationship mattered more than making a sale.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Row 2 — remaining story LEFT, hairdressing photo RIGHT */}
      <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-20 bg-background-50">
        <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal className="space-y-5 text-base md:text-lg leading-relaxed text-foreground-700">
            <p>
              I&rsquo;ve always loved discovering talented people, interesting services and new
              ideas, then sharing what I found. Sometimes it was a tailor or creative specialist;
              other times, an appropriately qualified professional. As introductions led to positive
              experiences, people came back. I realised that connecting people thoughtfully was
              something valuable I could offer beyond styling.
            </p>
            <p>
              That&rsquo;s where KOR38 began. To me it represents a centre of connection: a meeting
              point for the relationships, discoveries and knowledge gathered throughout my life. My
              approach is simple: listen carefully, recommend honestly, and connect thoughtfully.
              Because sometimes, the right connection opens an entirely new chapter.
            </p>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative w-full aspect-[4/5] max-w-md mx-auto lg:ml-auto lg:mr-0 overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/60994e3f-e9d4-45b8-a645-34865690ab4f_compressed_5bba2132-fe47-4a64-a3a8-757ceb7e2a6f-1_all_6218.webp"
                alt="Daniella at work as a session stylist, styling a client's hair"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600 max-w-md mx-auto lg:mr-0 lg:ml-0">
              Behind the scenes: session styling work in London.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 pb-20 md:pb-28 bg-background-50">
        <div className="max-w-content mx-auto flex justify-center">
          <Button to="/contact" variant="primary" size="lg">
            Let&rsquo;s Connect
          </Button>
        </div>
      </section>
    </>
  );
}